import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import InvoiceDetailsContextProvider from 'src/sections/invoice_details/InvoiceDetailsContext';
import InvoiceScans from 'src/sections/invoice_details/InvoiceScans';
import PoRelatedDocumentsContextProvider from 'src/sections/po_related_documents/PoRelatedDocumentsContext';

function InvoiceDetails() {
  const [searchParams] = useSearchParams();
  const [poId, setPoId] = useState(searchParams.get('poid') || '');

  return (
    <>
      <PoRelatedDocumentsContextProvider poId={poId}>
        <InvoiceDetailsContextProvider setPoId={setPoId}>
          <InvoiceScans />
        </InvoiceDetailsContextProvider>
      </PoRelatedDocumentsContextProvider>
    </>
  );
}

export default InvoiceDetails;
